<template>
	<v-card>
		<v-card-title>
			<h2>Udostępnienia do podglądu
				<template v-if="user">- {{user.name}} {{user.surname}} ({{user.systemRole}})</template>
			</h2>
		</v-card-title>
		<br>
		<egranty-section-divider
			text="Udostępnione oferty"
		/>
		<div v-for="offerBasicData in allowedOffersBasicData" :key="'offer-' + offerBasicData.id">
			<v-card>
				<v-layout row>
					<h3 style="padding: 10px">{{offerBasicData.offerCode}} &emsp;{{offerBasicData.title}}</h3>
					<egranty-icon-button
						label="Usuń"
						color= "lightred"
						icon="delete"
						@click="() => deleteAllowance(allowanceType.singleOffer, offerBasicData.id)"
					/>
				</v-layout>
			</v-card>
		</div>
		<br>
		<v-btn @click="openAddOfferAllowance">
			Dodaj kolejną
		</v-btn>
		<egranty-input-field-popup
			title="Udostępnij ofertę do podglądu"
			label="Numer oferty"
			:is-open.sync="addOfferOpen"
			@save="addOfferAllowance"
		/>

		<br>
		<egranty-section-divider
			text="Udostępnione projekty"
		/>
		<div v-for="projectBasicData in allowedProjectsBasicData" :key="'project-' + projectBasicData.id">
			<v-card>
				<v-layout row>
					<h3 style="padding: 10px">{{projectBasicData.projectCode}} &emsp;{{projectBasicData.title}}</h3>
					<egranty-icon-button
						label="Usuń"
						color= "lightred"
						icon="delete"
						@click="() => deleteAllowance(allowanceType.singleProject, projectBasicData.id)"
					/>
				</v-layout>
			</v-card>
		</div>
		<br>
		<v-btn @click="openAddProjectAllowance">
			Dodaj kolejny
		</v-btn>
		<egranty-input-field-popup
			title="Udostępnij projekt do podglądu"
			label="Numer projektu"
			:is-open.sync="addProjectOpen"
			@save="addProjectAllowance"
		/>

		<br>
		<egranty-section-divider
			text="Udostępnione sprawozdania z konkursów"
		/>
		<div v-for="reportBasicData in allowedReportsBasicData" :key="'report-' + reportBasicData.id">
			<v-card>
				<v-layout row>
					<h3 style="padding: 10px">{{reportBasicData.projectCode}}
						&emsp;{{reportBasicData.projectTitle}}</h3>
					<egranty-icon-button
						label="Usuń"
						color="lightred"
						icon="delete"
						@click="() => deleteAllowance(allowanceType.singleReport, reportBasicData.id)"
					/>
				</v-layout>
			</v-card>
		</div>
		<br>
		<v-btn @click="openAddReportAllowance">
			Dodaj kolejne
		</v-btn>
		<egranty-input-field-popup
			title="Udostępnij sprawozdanie do podglądu"
			label="Numer projektu"
			:is-open.sync="addReportOpen"
			@save="addReportAllowance"
		/>

		<br>
		<egranty-section-divider
			text="Udostępnione projekty i wnioski placówek"
		/>
		<div v-for="agencyProjectBasicData in allowedAgencyProjectsBasicData"
			:key="'agency-project-' + agencyProjectBasicData.id">
			<v-card>
				<v-layout row>
					<h3 style="padding: 10px">{{agencyProjectBasicData.agencyProjectCode}} &emsp;
						{{agencyProjectBasicData.title}}</h3>
					<egranty-icon-button
						color= "lightred"
						label="Usuń"
						icon="delete"
						@click="() => deleteAllowance(allowanceType.singleAgencyProject, agencyProjectBasicData.id)"
					/>
				</v-layout>
			</v-card>
		</div>
		<br>
		<v-btn @click="openAddAgencyProjectAllowance">
			Dodaj kolejny
		</v-btn>
		<egranty-input-field-popup
			title="Udostępnij projekt/wniosek placówki do podglądu"
			label="Numer projektu/wniosku"
			:is-open.sync="addAgencyProjectOpen"
			@save="addAgencyProjectAllowance"
		/>

		<br>
		<egranty-section-divider
			text="Udostępnione sprawozdania z naborów"
		/>
		<div v-for="agencyReportBasicData in allowedAgencyReportsBasicData"
			:key="'agency-report-' + agencyReportBasicData.id">
			<v-card>
				<v-layout row>
					<h3 style="padding: 10px">{{agencyReportBasicData.projectCode}} &emsp;{{agencyReportBasicData.projectTitle}}</h3>
					<egranty-icon-button
						label="Usuń"
						color="lightred"
						icon="delete"
						@click="() => deleteAllowance(allowanceType.singleAgencyReport, agencyReportBasicData.id)"
					/>
				</v-layout>
			</v-card>
		</div>
		<br>
		<v-btn @click="openAddAgencyReportAllowance">
			Dodaj kolejne
		</v-btn>
		<egranty-input-field-popup
			title="Udostępnij sprawozdanie do podglądu"
			label="Numer projektu"
			:is-open.sync="addAgencyReportOpen"
			@save="addAgencyReportAllowance"
		/>
	</v-card>
</template>

<script>
	import EgrantyInputFieldPopup from "../../../genericComponents/EgrantyInputFieldPopup";
	import EgrantySectionDivider from "../../../genericComponents/EgrantySectionDivider";
	import {Offer} from "../../../api/generated/Offer";
	import {Allowance} from "../../../api/generated/Allowance";
	import EgrantyIconButton from "../../../genericComponents/EgrantyIconButton";
	import {Project} from "../../../api/generated/Project";
	import {AgencyProject} from "../../../api/generated/AgencyProject";
	import {User} from "../../../api/generated/User";
	import {FinalReport} from "../../../api/generated/FinalReport";
	import {AgencyFinalReport} from "../../../api/generated/AgencyFinalReport";

	export default {
		name: "AllowancesView",
		components: {EgrantyIconButton, EgrantySectionDivider, EgrantyInputFieldPopup},
		data () {
			return {
				addOfferOpen: false,
				addAgencyProjectOpen: false,
				addProjectOpen: false,
				addReportOpen: false,
				addAgencyReportOpen: false,
				addContestOpen: false,
				addAgencyContestOpen: false,
				userAllowances: [],
				allowedOffersBasicData: [],
				allowedProjectsBasicData: [],
				allowedReportsBasicData: [],
				allowedAgencyProjectsBasicData: [],
				allowedAgencyReportsBasicData: [],
				userId: this.$route.params.userId,
				user: null,

				allowanceType: {
					singleOffer: "SINGLE_OFFER",
					singleProject: "SINGLE_PROJECT",
					singleAgencyProject: "SINGLE_AGENCY_PROJECT",
					singleReport: "SINGLE_REPORT",
					singleAgencyReport: "SINGLE_AGENCY_REPORT",
					wholePublicContest: "WHOLE_PUBLIC_CONTEST",
					wholeAgencyContest: "WHOLE_AGENCY_CONTEST"
				}
			};
		},

		methods: {

			deleteAllowance (type, id) {
				Allowance.deleteAllowance(this, this.userId, this.createAllowanceDTO(type, id), () => this.loadAllowances());
			},

			getAllowedObjectsIdsByType (type, allowances) {
				return allowances.filter(x => x.allowanceType === type).map(x => x.allowedObjectId);
			},

			createAllowanceDTO (type, id) {
				return {
					userId: this.userId,
					allowedObjectId: id,
					allowanceType: type
				};
			},

			openAddOfferAllowance () {
				this.addOfferOpen = true;
			},

			loadUserData () {
				User.getUserInfoById(this, this.userId, successResponse => {
						this.user = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować danych o użytkowniku", errorResponse);
					});
			},

			loadAllowances () {
				Allowance.getUserAllowances(this, this.userId, response => {
					this.userAllowances = response;

					let offerAllowancesIds = this.getAllowedObjectsIdsByType(this.allowanceType.singleOffer, this.userAllowances);
					Offer.getBasicDataList(this, offerAllowancesIds, response => {
						this.allowedOffersBasicData = response;
					});
					let projectAllowancesIds = this.getAllowedObjectsIdsByType(this.allowanceType.singleProject, this.userAllowances);
					Project.getBasicDataList(this, projectAllowancesIds, response => {
						this.allowedProjectsBasicData = response;
					});
					let reportAllowancesIds = this.getAllowedObjectsIdsByType(this.allowanceType.singleReport, this.userAllowances);
					FinalReport.getBasicDataList(this, reportAllowancesIds, response => {
						this.allowedReportsBasicData = response;
					});
					let agencyProjectAllowancesIds = this.getAllowedObjectsIdsByType(this.allowanceType.singleAgencyProject, this.userAllowances);
					AgencyProject.getBasicDataList(this, agencyProjectAllowancesIds, response => {
						this.allowedAgencyProjectsBasicData = response;
					});
					let agencyReportAllowancesIds = this.getAllowedObjectsIdsByType(this.allowanceType.singleAgencyReport, this.userAllowances);
					AgencyFinalReport.getBasicDataList(this, agencyReportAllowancesIds, response => {
						this.allowedAgencyReportsBasicData = response;
					});
				});
			},

			addOfferAllowance (offerCode) {
				Offer.getBasicDataByCode(this, offerCode, (response) => {
					Allowance.putAllowance(
						this,
						this.createAllowanceDTO(this.allowanceType.singleOffer, response.id),
						() => this.loadAllowances()
					);
				});
				this.addOfferOpen = false;
			},

			openAddProjectAllowance () {
				this.addProjectOpen = true;
			},

			openAddReportAllowance () {
				this.addReportOpen = true;
			},

			openAddAgencyReportAllowance () {
				this.addAgencyReportOpen = true;
			},

			addProjectAllowance (projectCode) {
				Project.getBasicDataByCode(this, projectCode, (response) => {
					Allowance.putAllowance(
						this,
						this.createAllowanceDTO(this.allowanceType.singleProject, response.id),
						() => this.loadAllowances()
					);
				});
				this.addProjectOpen = false;
			},

			addReportAllowance (projectCode) {
				FinalReport.getBasicDataByProjectCode(this, projectCode, (response) => {
					Allowance.putAllowance(
						this,
						this.createAllowanceDTO(this.allowanceType.singleReport, response.id),
						() => this.loadAllowances()
					);
				});
				this.addReportOpen = false;
			},

			addAgencyReportAllowance (projectCode) {
				AgencyFinalReport.getBasicDataByProjectCode(this, projectCode, (response) => {
					Allowance.putAllowance(
						this,
						this.createAllowanceDTO(this.allowanceType.singleAgencyReport, response.id),
						() => this.loadAllowances()
					);
				});
				this.addAgencyReportOpen = false;
			},

			openAddAgencyProjectAllowance () {
				this.addAgencyProjectOpen = true;
			},

			addAgencyProjectAllowance (agencyProjectCode) {
				AgencyProject.getBasicDataByCode(this, agencyProjectCode, (response) => {
					Allowance.putAllowance(
						this,
						this.createAllowanceDTO(this.allowanceType.singleAgencyProject, response.id),
						() => this.loadAllowances()
					);
				});
				this.addAgencyProjectOpen = false;
			},
		},

		mounted () {
			this.loadUserData();
			this.loadAllowances();
		}
	};
</script>

<style scoped>

</style>